import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileBarChart, FileSpreadsheet, FileText } from "lucide-react";
import { API } from "../../../config";

export const SmsMonthlyReport = () => {
  const [months, setMonths] = useState([]);
  const [month, setMonth] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => {
    axios.get(`${API}/admin/sms-credit/report-months`).then((r) => {
      setMonths(r.data.months);
      if (r.data.months.length) setMonth(r.data.months[0].month);
    }).catch(() => setMonths([]));
  }, []);

  const download = async (fmt) => {
    setBusy(fmt);
    try {
      const r = await axios.get(`${API}/admin/sms-credit/monthly-report.${fmt}`, { params: { month }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `Report_SMS_LoJack_${month}.${fmt}`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download report non riuscito"); }
    setBusy("");
  };

  return (
    <div className="bg-[#111] border border-gray-800 rounded-2xl p-6 flex items-center justify-between flex-wrap gap-4" data-testid="sms-monthly-report">
      <div>
        <p className="flex items-center gap-2 text-white font-semibold"><FileBarChart size={18} /> Report mensile SMS</p>
        <p className="text-xs text-gray-400 mt-1">SMS inviati, spesa per paese, ricariche e saldo del mese selezionato</p>
      </div>
      {months.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="sms-report-no-months">Nessun movimento registrato</p>
      ) : (
        <div className="flex items-center gap-2 flex-wrap">
          <select value={month} onChange={(e) => setMonth(e.target.value)} data-testid="sms-report-month-select"
            className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white text-sm outline-none focus:border-gray-500">
            {months.map((m) => <option key={m.month} value={m.month}>{m.label}</option>)}
          </select>
          <button onClick={() => download("pdf")} disabled={!!busy} className="btn-lojack-outline text-sm flex items-center gap-1" data-testid="sms-report-download-pdf">
            <FileText size={14} /> {busy === "pdf" ? "Generazione…" : "Scarica PDF"}
          </button>
          <button onClick={() => download("csv")} disabled={!!busy} className="btn-lojack-outline text-sm flex items-center gap-1" data-testid="sms-report-download-csv">
            <FileSpreadsheet size={14} /> {busy === "csv" ? "Generazione…" : "Scarica CSV"}
          </button>
        </div>
      )}
    </div>
  );
};
